<template>
  <div class="article">
    <TheArticleHeader/>
    <div class="article__view">
      <router-view />
    </div>
    <div class="article__footer">
      <OutlinesButton text="回首頁" @click.native.prevent="onHomeClick"/>
      <OutlinesButton :text="nextTitle" @click.native.prevent="onNextClick"/>
    </div>
    <TheComments url="https://udn.com/newmedia/election2020/chuchupepper/"/>
  </div>
</template>

<script>
import TheArticleHeader from '@/components/TheArticleHeader'
import OutlinesButton from '@/components/OutlinesButton'
import TheComments from '@/components/TheComments'

export default {
  name: 'Article',
  components: {
    TheArticleHeader,
    OutlinesButton,
    TheComments
  },
  computed: {
    nextId () {
      let paths = this.$route.path.slice('/')
      let id = Number(paths[paths.length - 1]) + 1
      return (id > 3) ? 1 : id
    },
    nextTitle () {
      return this.nextId === 1 ? '第一篇' : '下一篇'
    }
  },
  methods: {
    onHomeClick () {
      this.$router.push({ name: 'home' })
    },
    onNextClick () {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Link',
        'eventAction': 'Click',
        'eventLabel': `Next-to-article-${this.nextId}`
      })
      this.$router.push({ name: `article-${this.nextId}` })
    }
  }
}
</script>

<style lang="scss">
.article {
  @include rwd($RWD_TABLET) {
    padding-right: 70px;
  }

  .the-article-header {
    max-height: 416px;
  }

  &__view {
    @include use-layer(&);
    position: relative;
    max-width: 1160px;
    margin: 0 auto;
  }

  &__info {
    padding: 22px 12px 0 20px;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 35px 35px 0 35px;
    }
    @include rwd($RWD_TABLET) {
      padding: 35px 47px 0 47px;
    }
    @include rwd($RWD_DESKTOP) {
      float: left;
      width: 41%;
      margin-top: -50px;
      padding: 0 0 0 45px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 43%;
      margin-top: 50px;
      padding: 0;
    }
  }

  &__title {
    // color: #1a1a1a;
    // font-size: 1.5em;
    // font-weight: bold;
    // line-height: 1.25em;
    // letter-spacing: 0.1em;
    // @include rwd($RWD_TABLET_SMALL) {
    //   margin: 35px 35px 0 35px;
    // }
    // @include rwd($RWD_TABLET) {
    //   margin: 35px 47px 0 47px;
    // }
    // @include rwd($RWD_DESKTOP) {}
    // @include rwd($RWD_DESKTOP_WIDE) {}
    span {
      display: block;
      color: #1a1a1a;
      font-size: 1.5em;
      font-weight: bold;
      line-height: 1.25em;
      letter-spacing: 0.08em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.875em;
        line-height: 1.2em;
      }
      @include rwd($RWD_TABLET) {
        font-size: 2.25em;
        line-height: 1.333em;
      }
      @include rwd($RWD_DESKTOP) {
        font-size: 1.875em;
        line-height: 1.2em;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        font-size: 2.5em;
        line-height: 1.2em;
      }

      &:first-child {
        margin-left: 2px;
        color: #e4007f;
        font-size: 1em;
        line-height: 1.5em;
        letter-spacing: 0.1em;
        @include rwd($RWD_TABLET_SMALL) {
          font-size: 1.375em;
          line-height: 1.364em;
        }
        @include rwd($RWD_TABLET) {
          font-size: 1.5em;
          line-height: 1.25em;
        }
        @include rwd($RWD_DESKTOP) {
          font-size: 1.375em;
          line-height: 1.364em;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
        }
      }

      & + span {
        margin-top: 5px;
      }
    }
  }

  &__reporter {
    margin: 12px 2px;
    font-size: 0.875em;
    font-weight: bold;
    line-height: 1.5em;
    letter-spacing: 0.1em;
    text-align: justify;
      text-justify: inter-word;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 18px 4px 15px 4px;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1em;
    }
    @include rwd($RWD_DESKTOP) {
      margin: 25px 4px 30px 4px;
      font-size: 0.875em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin: 25px 4px 35px 4px;
      font-size: 1em;
    }
  }

  &__figure {
    display: block;
    margin: 0;
    padding: 10px;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 10px 0;
    }
    @include rwd($RWD_TABLET) {
      padding: 10px 45px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE) {}

    &-photo {
      background: #e6e6e6 no-repeat top center / cover;
      @include use-fixed-ratio(4, 3);
    }

    &-caption {
      position: relative;
      margin: 12px 0 12px 35px;
      font-size: 0.875em;
      font-weight: bold;
      line-height: 1.71em;
      letter-spacing: 0.1em;
      text-align: justify;
      text-justify: inter-word;
      @include rwd($RWD_TABLET_SMALL) {
        margin: 12px 36px 12px 70px;
        font-size: 1em;
      }
      @include rwd($RWD_TABLET) {
        margin: 12px 48px 12px 35px;
      }
      @include rwd($RWD_DESKTOP) {
        margin: 12px 0 12px 35px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {}

      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 63px;
        height: 0;
        border-top: 1px solid #e4007f;
        transform: translate(-68%, 0) rotate(-45deg);
      }
    }
  }

  &__cover {
    position: relative;
    @include rwd($RWD_DESKTOP) {
      float: right;
      width: 59%;
      margin-top: -18%;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 57%;
      margin-top: -26%;
      // margin-right: -20px;
      padding: 10px 10px 10px 40px;
    }
  }

  &__subtitle {
    margin: 35px 20px 10px 20px;
    color: #e4007f;
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.2em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 50px 35px 15px 35px;
      font-size: 1.5em;
      line-height: 1.25em;

    }
    @include rwd($RWD_TABLET) {
      margin: 50px 50px 15px 50px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE) {
      margin: 50px 0 15px 0;
      font-size: 1.875em;
      line-height: 1.2em;
    }
  }

  &__subtitle + &__paragraph {
    margin: 10px 20px;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 15px 35px;
    }
    @include rwd($RWD_TABLET) {
      margin: 15px 50px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE) {
      margin: 15px 0 15px 0;
    }
  }

  &__paragraph {
    margin: 20px 20px;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.5em;
    letter-spacing: 0.1em;
    text-align: justify;
    text-justify: inter-word;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 25px 35px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_TABLET) {
      margin: 35px 50px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE) {
      margin: 35px 0 35px 0;
    }

    &:first-of-type {
      @include rwd($RWD_DESKTOP) {
        clear: left;
      }
    }
  }

  &__footer {
    margin: 50px 0 0 0;
    text-align: center;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 50px 0 10px 0;
    }
    @include rwd($RWD_TABLET) {
      margin: 60px 0 30px 0;
    }
    @include rwd($RWD_DESKTOP) {
      margin: 50px 0 30px 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin: 70px 0 20px 0;
    }

    .outlines-button {
      min-width: 130px;
      @include rwd($RWD_TABLET) {
        min-width: 160px;
      }
      @include rwd($RWD_DESKTOP) {
        min-width: 143px;
      }
      &__text {
        @include rwd($RWD_TABLET) {
          font-size: 1.125em;
          line-height: 1.667em;
          letter-spacing: 0.1em;
        }
        @include rwd($RWD_DESKTOP) {
          font-size: 1em;
          line-height: 1.875em;
          letter-spacing: 0.1em;
        }
      }

      & + .outlines-button {
        margin-left: 20px;
      }
    }
  }

  &__chart {
    width: 100%;
    padding: 40px 20px;

    @include rwd($RWD_TABLET_SMALL) {
      padding: 40px 35px;
    }

    @include rwd($RWD_TABLET) {
      padding: 40px 50px;
    }

    @include rwd($RWD_DESKTOP) {
      padding: 60px 70px;
    }
  }

  &__chart &__chart-caption {
    padding-bottom: 15px;
    font: normal 100%/150% "Montserrat", "Noto Sans TC", "Noto Serif TC", sans-serif;
    font-size: 0.9375em;
    text-align: center;

    @include rwd($RWD_TABLET) {
      font-size: 1em;
    }

    @include rwd($RWD_DESKTOP) {
      padding-bottom: 20px;
    }
  }

  &__chart-table {
    position: relative;
    color: #1A1A1A;

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__chart-guide {
    margin: 10px 5px 0 5px;
    color: #7e7e7e;
    font: normal 100%/150% "Montserrat", "Noto Sans TC", "Noto Serif TC", sans-serif;
    font-size: 0.75em;
    text-align: right;
  }

  &__chart-guide p {
    margin-block-start: 0;
    margin-block-end: 0;

    @include rwd($RWD_TABLET) {
      float: left;

      & + p {
        float: right;
      }
    }
  }
}
</style>
